var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"size":_vm.size,"color":_vm.color,"viewBox":"0 0 200 200"}},[_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M193.5,60.8L86.2,168.3c-4.2,3.9-9.4,6.2-14.9,6.2c-5.2,0-10.7-2.3-14.6-6.2L6.5,118.1   c-8.1-8.1-8.1-21.4,0-29.5s21.1-8.1,29.2,0l35.6,35.6L164,31.6c8.1-8.1,21.4-8.1,29.5,0S201.6,52.7,193.5,60.8z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }